import { useState } from 'react';
import CodeSnippet from '../CodeSnippet';

const LANGUAGES = [
  { id: 'bash', label: 'Bash' },
  { id: 'python', label: 'Python' },
  { id: 'javascript', label: 'JavaScript' },
];

function buildSnippets(base, token) {
  return {
    bash: {
      language: 'bash',
      code: `curl ${base}/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "claude-haiku-4.5",
    "messages": [{"role": "user", "content": "Hello from os-router"}]
  }'`,
    },
    python: {
      language: 'python',
      code: `import requests

response = requests.post(
    "${base}/chat/completions",
    headers={
        "Authorization": "Bearer ${token}",
        "Content-Type": "application/json",
    },
    json={
        "model": "claude-haiku-4.5",
        "messages": [{"role": "user", "content": "Hello from os-router"}],
    },
)
print(response.json())`,
    },
    javascript: {
      language: 'javascript',
      code: `const response = await fetch("${base}/chat/completions", {
  method: "POST",
  headers: {
    Authorization: "Bearer ${token}",
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    model: "claude-haiku-4.5",
    messages: [{ role: "user", content: "Hello from os-router" }],
  }),
});

const data = await response.json();
console.log(data);`,
    },
  };
}

export default function IntegrateAPI({ apiUrl, tokenPlaceholder }) {
  const [lang, setLang] = useState('bash');
  const base = `${apiUrl || 'https://api.osrouter.dev'}/api/v1`;
  const snippets = buildSnippets(base, tokenPlaceholder);
  const active = snippets[lang];

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-2">REST API</h1>
      <p className="text-sm opacity-60 mb-6">
        os-router is OpenAI-compatible. Point any HTTP client at our API and pass your os-router key.
      </p>

      <CodeSnippet
        code={active.code}
        language={active.language}
        languages={LANGUAGES}
        activeLanguage={lang}
        onLanguageChange={setLang}
      />
      <p className="text-sm opacity-60 mt-4">
        Base URL: <code className="text-theme-primary">{base}</code>
      </p>
    </div>
  );
}
